import { AccountDetailsParameters } from './AccountDetailsParameters';

export class ProviderParameters {
  Name: string;
  FirstName: string;
  LastName: string;
  DisplayName: string;
  TempPassword: string;
  RoleId: number;
  StatusId: number;
  CountryId: number;
  City: string;
  Address: string;
  Email: string;
  PhoneNumber: string;
  TypeId: number;
  ContractNo: string;
  ProcedureCodesetId: string;
  DiagnosisCodesetId: string;
  DentalCodesetId: string;
  DrugCodesetId: string;
  CurrencyId: number;
  TimezoneId: number;
  BankDetailsId: number;
  BankDetails: BankDetailParameters;
  AccountDetails: AccountDetailsParameters;
  RejectionReason: string;
}

export class CurrencyParameters {
  Id: number;
  Name: string;
}

export class TimezoneParameters {
  Id: number;
  Name: string;
}

export class RoleParameters {
  Id: number;
  Name: string;
}

export class BankDetailParameters {
  Id: number;
  Name: string;
  AccountNumber: string;
  IBAN: string;
  SwiftCode: string;
  BankLetter: any;
  RoutingNumber: string;
}